/* ===========================================================
   Elite Supplements — Store Detail Page interactions
   =========================================================== */
(function () {
  'use strict';

  /* ---------- Sticky nav: stuck shadow + active section ---------- */
  var quicknav = document.getElementById('quicknav');
  var links    = Array.prototype.slice.call(document.querySelectorAll('#quicklinks a'));

  window.addEventListener('scroll', function () {
    if (window.scrollY > 80) quicknav.classList.add('is-stuck');
    else quicknav.classList.remove('is-stuck');
  }, { passive: true });

  var sections = links.map(function (a) {
    return document.querySelector(a.getAttribute('href'));
  }).filter(Boolean);

  if ('IntersectionObserver' in window) {
    var spy = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var id = en.target.id;
        links.forEach(function (a) {
          a.classList.toggle('is-active', a.getAttribute('href') === '#' + id);
        });
      });
    }, { rootMargin: '-45% 0px -50% 0px', threshold: 0 });
    sections.forEach(function (s) { spy.observe(s); });
  }

  /* ---------- FAQ accordion ---------- */
  document.querySelectorAll('#store-faq .faq-item').forEach(function (item) {
    var btn   = item.querySelector('.faq-q');
    var panel = item.querySelector('.faq-a');
    btn.addEventListener('click', function () {
      var open = item.classList.contains('is-open');
      document.querySelectorAll('#store-faq .faq-item.is-open').forEach(function (o) {
        if (o !== item) { o.classList.remove('is-open'); o.querySelector('.faq-a').style.maxHeight = null; }
      });
      if (open) {
        item.classList.remove('is-open');
        panel.style.maxHeight = null;
      } else {
        item.classList.add('is-open');
        panel.style.maxHeight = panel.scrollHeight + 'px';
      }
    });
  });

  /* ---------- Opening hours / open-closed / rating / reviews / address ----------
     Handled live by store-places.js via the Google Maps Places API.
     See data-place-* hooks in the section markup. ---------- */

  /* ---------- Gallery lightbox ---------- */
  var items = Array.prototype.slice.call(document.querySelectorAll('#gallery-grid .gallery-item'));
  var lb    = document.getElementById('lightbox');
  var lbImg = document.getElementById('lb-img');
  var lbCap = document.getElementById('lb-caption');
  var idx   = 0;

  function showAt(i) {
    idx = (i + items.length) % items.length;
    var item = items[idx];
    var imgEl = item.querySelector('img');
    if (imgEl && lbImg) { lbImg.src = imgEl.src; lbImg.alt = imgEl.alt || ''; }
    if (lbCap) lbCap.textContent = item.getAttribute('data-cap') || '';
  }
  function openLb(i)  { showAt(i); lb.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
  function closeLb()  { lb.classList.remove('is-open'); document.body.style.overflow = ''; }

  items.forEach(function (item, i) {
    item.addEventListener('click', function () { openLb(i); });
  });
  if (lb) {
    document.getElementById('lb-close').addEventListener('click', closeLb);
    document.getElementById('lb-next').addEventListener('click',  function () { showAt(idx + 1); });
    document.getElementById('lb-prev').addEventListener('click',  function () { showAt(idx - 1); });
    lb.addEventListener('click', function (e) { if (e.target === lb) closeLb(); });
  }
  document.addEventListener('keydown', function (e) {
    if (!lb || !lb.classList.contains('is-open')) return;
    if (e.key === 'Escape')     closeLb();
    if (e.key === 'ArrowRight') showAt(idx + 1);
    if (e.key === 'ArrowLeft')  showAt(idx - 1);
  });

  /* ---------- Smooth-scroll offset for sticky nav ---------- */
  document.querySelectorAll('a[href^="#"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var id = a.getAttribute('href');
      if (id.length < 2) return;
      var el = document.querySelector(id);
      if (!el) return;
      e.preventDefault();
      var y = el.getBoundingClientRect().top + window.scrollY - 70;
      window.scrollTo({ top: y, behavior: 'smooth' });
    });
  });

})();
